import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { CompanyProfile } from '../types/company';

export const queryKey = 'navbar-company';

/**
 * @deprecated Prefer `useCurrentCompany` from `@bonusly/who-am-i` instead. More fields can be added to the response if needed.
 */
export const useCompanyProfile = () => {
	const http = useHttpClient();

	const query = useQuery(
		[queryKey],
		() => {
			return http.get<{ result: CompanyProfile }>('/profile/company', {
				params: { view: 'profile' },
			});
		},
		{
			refetchInterval: Infinity,
			select: (data) => data.data.result,
		}
	);

	return { ...query, company: query.data as CompanyProfile };
};
